import { action, computed, observable, runInAction, toJS } from "mobx";
import { Root } from "./store-root";
import { agents } from "../api/agent";
import { UserProfile } from "../models/user-profile";
import {API} from 'aws-amplify';

export class AgentStore {
  parent: Root;
  @observable agentRegistry = new Map();
  @observable isLoadingInitial: boolean = false;
  @observable agent: UserProfile | undefined = undefined;

  constructor(root: Root) {
    this.parent = root;
  }


  @action loadAgent = async (id: string) => {
    let agent = this.getAgent(id);
    console.log("Agent ",toJS(agent));
    if (agent) {
      this.agent = agent;
      return toJS(agent);
    } else {
      try {
        agent = await API.get('backend',`/users/${id}`,{});
        runInAction(() => {
          this.agent = agent;
          this.agentRegistry.set(agent.userName, agent);
        });
        return agent;
      } catch (error) {
        console.log(error);
      }
    }
  };

  getAgent = (id: string) => {
    return this.agentRegistry.get(id);
  };

  @action loadAgents = async () => {
    this.isLoadingInitial = true;

    try {
      //Load from backend
      //Todo : Build lamda function that load user profiles from the backend

      this.agentRegistry.clear();
     const fromBackEnd:UserProfile[] = await API.get('backend','/users',{})

      //Load  the local registery
      runInAction("loading local agents registry", () => {
        fromBackEnd.forEach((item: UserProfile) => {
          this.agentRegistry.set(item.UserName, item);
        });

        this.isLoadingInitial = false;
      });
    } catch (error) {
      //Todo : notify users with error toast

      runInAction("load agents error", () => {
        this.isLoadingInitial = false;
      });
    }
  };

  @computed get sendingAgents(){
    const filtered : UserProfile[]= Array.from(this.agentRegistry.values()).filter((item:UserProfile)=>(item.Role==='SEND_AGENT' || item.Role==='BUSINESS_ADMIN'))
    return filtered;
  }

  @computed get createdByCurrentUser(){
    const filtered : UserProfile[]= Array.from(this.agentRegistry.values()).filter((item:UserProfile)=>(item.ReportsTo===this.parent.Users.Sub))
    return filtered;
  }

  @computed get agentsByDate() {
    return this.getAgentsByDate(Array.from(this.agentRegistry.values()));
  }
  @action createUserProfile = async (user: UserProfile) => {
    await API.post("backend", "/users", {body:user});
  };

  @action saveUserProfile= async(user: UserProfile)=>{
    await API.put('backend',`/users/${user.UserName}`,{body:user});
  }

  getAgentsByDate = (agents: UserProfile[]) => {
    const sortedAgents = agents.sort((a, b) => {
      console.log("month", new Date("11/2/2020").getMonth());
      const x =
        new Date(a.CreatedAt).getUTCDate() - new Date(b.CreatedAt).getUTCDate();
      console.log(x);
      return x;
    });
    return sortedAgents;
  };
}
